// Utility for making authenticated API requests
export const authenticatedFetch = async (url: string, options: RequestInit = {}) => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    if (!user || !user.token) {
        throw new Error('No authentication token found');
    }

    const headers = {
        ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
        'Authorization': `Bearer ${user.token}`,
        ...options.headers
    };

    const response = await fetch(url, {
        ...options,
        headers
    });

    if (response.status === 401) {
        // Token is invalid, remove from storage and redirect to login
        localStorage.removeItem('user');
        window.location.href = '/login';
        throw new Error('Authentication failed');
    }

    return response;
};

// Helper to check if current user has admin rights
export const isCurrentUserAdmin = (): boolean => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    return user && user.rights === 'ADMIN';
};

// Helper to get current user
export const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem('user') || 'null');
};
